import(/* webpackMode: "eager" */ "/vercel/path0/app/(pages)/blog/NestedBlog.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js")